import styled from 'styled-components';
import { breakpoints, colorCSS, theme } from '../../styles';
export const Banner = styled.div `
  text-align: left;
  ${({ themeInitial }) => themeInitial
    ? `padding: 1.5rem; `
    : `padding: 1rem;
    @media (max-width: ${breakpoints.lg}px) {
      padding: 0;
      margin-bottom: 1.5rem;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  `}
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  ${({ themeInitial }) => themeInitial && `background-color: ${colorCSS(`${themeInitial}50`, 0.4)};`}
`;
export const BannerIcon = styled.div `
  svg {
    height: 1.2rem;
    margin-left: 0.4rem;
    margin-right: 0.8rem;
    width: auto;

    path {
      fill: ${({ themeInitial }) => colorCSS(themeInitial ? `${themeInitial}200` : 'N100')};
    }
  }
`;
export const BannerTitleContainer = styled.div `
  display: flex;
  ${({ themeInitial }) => themeInitial && `line-height: 1rem; padding-bottom: 0.25rem;`}
`;
export const BannerTitle = styled.div `
  width: 100%;
  p {
    color: ${colorCSS('N800')};
    font-weight: normal;
    font-family: ${theme.fontFamily.text};
    font-size: 1rem;
    line-height: 1.25rem;
    padding-right: 0.3rem;
    margin-bottom: 0.5rem !important;
  }
`;
export const BannerDescription = styled.div `
  color: ${colorCSS('N400')};
  font-size: 0.75rem;
  ${({ themeInitial }) => themeInitial && `line-height: 1rem; margin-bottom: 1rem;`}
`;
//# sourceMappingURL=UiNavBanner.styles.js.map